(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("StAnalyticsClient", [], factory);
	else if(typeof exports === 'object')
		exports["StAnalyticsClient"] = factory();
	else
		root["StAnalyticsClient"] = factory();
})(typeof self !== "undefined" ? self : this, function() {
return 